/**
 * Client-side configuration. Public identifiers only - nothing secret belongs here.
 *
 * Override with VITE_API_BASE_URL for local (`http://localhost:7071`). Production defaults
 * to the custom API host.
 */

export const TENANT_ID = '8014197f-b520-4389-a80e-860479d46243';
export const CLIENT_ID = '60707f82-733a-4b16-a904-a5d508cbc696';

/** Scope granted by the Entra app registration. Easy Auth validates this audience. */
export const API_SCOPE = `api://${CLIENT_ID}/access_as_user`;

export const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`;

const DEFAULT_API_BASE = 'https://swsd-olk-api.ameritex.com';

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(
  /\/+$/,
  '',
) ?? DEFAULT_API_BASE;

export const APP_VERSION = '0.1.0';
